import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { deleteData, getData } from '../Services/api'
import { toast } from 'react-toastify'
import Swal from 'sweetalert2'
import Pagination from '../Services/Pagination';

const RouteList = () => {
  const [route, setRoute] = useState([]);
  const [page, setPage] = useState(1);
  const [pages, setPages] = useState(1);
  const [total, setTotal] = useState(0);

  const [search, setSearch] = useState("");

  const fetchRoutes = async (pageNumber = page, searchQuery = search) => {
    try {
      const query = new URLSearchParams({
        page: pageNumber,
        limit: 10,
        search: searchQuery,
      }).toString();

      const res = await getData(`/routes/filter-with-pagination?${query}`);
      if (res.status) {
        setRoute(res.data || []);
        setPage(res.currentPage || 1);
        setPages(res.totalPages || 0);
        setTotal(res.totalRecords || 0);
      }
    } catch (error) {
      console.log("error fetch routes", error);
    }
  };

  useEffect(() => {
    fetchRoutes();
  }, []);

  const handleDelete = (routeId) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, cancel!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const res = await deleteData(`/routes/delete/${routeId}`);
          if (res.status) {
            toast.success(res.message);
            fetchRoutes();
          }
        } catch (error) {
          console.log("error delete routes", error)
        }
      }
    });
  };

  const handleSearch = (e) => {
    e.preventDefault();
    fetchRoutes(1, search); // reset page to 1 on new search
  };

  return (
    <>
      <div className="pc-container">
        <div className="pc-content">
          <div className="page-header">
            <div className="page-block">
              <div className="row align-items-center">
                <div className="col-md-12">
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/">Home</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/routes/route-list">Route</Link>
                    </li>
                    <li className="breadcrumb-item" aria-current="page">
                      Routes
                    </li>
                  </ul>
                </div>
                <div className="col-md-12 d-flex justify-content-between align-items-center">
                  <div className="page-header-title">
                    <h2 className="mb-0">Routes</h2>
                  </div>
                  <Link to="/routes/add-route"
                    className="btn btn-primary d-inline-flex align-item-center"
                  >
                    <i className="fas fa-plus f-18 mx-2" /> Add Route
                  </Link>
                </div>
              </div>
            </div>
          </div>

          {/* 🔍 Search Filter */}
          <div className="row mb-3">
            <div className="col-md-6">
              <form onSubmit={handleSearch} className="d-flex">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search by route name or salesperson..."
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
                <button type="submit" className="btn btn-primary ms-2">Search</button>
              </form>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-12">
              <div className="card table-card">
                <div className="card-body">
                  <div className="table-responsive">
                    <table className="table table-hover" id="pc-dt-simple">
                      <thead>
                        <tr>
                          <th>S.No.</th>
                          <th>Route Id</th>
                          <th>Route Name</th>
                          <th>Sales person</th>
                          <th className="text-center">Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {
                          route?.length > 0 ? (
                            route?.map((quote, index) => (
                              <tr key={quote.id}>
                                <td>{(page - 1) * 10 + index + 1}.</td>
                                <td>{quote.id}</td>
                                <td>{quote.route_name}</td>
                                <td>{quote.salespersons}</td>
                                <td className="text-center">
                                  <ul className="list-inline me-auto mb-0">
                                    <li className="list-inline-item align-bottom" data-bs-toggle="tooltip" title="View">
                                      <Link to={`/routes/view-route/${quote.id}`} className="avtar avtar-xs btn-link-secondary btn-pc-default">
                                        <i className="fas fa-eye f-18" />
                                      </Link>
                                    </li>
                                    <li className="list-inline-item align-bottom" data-bs-toggle="tooltip" title="Edit">
                                      <Link to={`/routes/update-route/${quote.id}`} className="avtar avtar-xs btn-link-success btn-pc-default">
                                        <i className="fas fa-edit f-18" />
                                      </Link>
                                    </li>
                                    <li className="list-inline-item align-bottom" data-bs-toggle="tooltip" title="Delete">
                                      <button onClick={() => handleDelete(quote.id)} className="avtar avtar-xs btn-link-danger btn-pc-default">
                                        <i className="fas fa-trash f-18" />
                                      </button>
                                    </li>
                                  </ul>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td className='text-center' colSpan={6}>No Data Found.</td>
                            </tr>
                          )
                        }
                      </tbody>
                    </table>
                  </div>
                  <div className="d-flex justify-content-between align-items-center px-4 pb-3">
                    <div className="text-muted">
                      Showing {(page - 1) * 10 + 1} to {Math.min(page * 10, total)} of {total} entries
                    </div>
                    <Pagination
                      page={page}
                      pages={pages}
                      onPageChange={(pageNumber) => fetchRoutes(pageNumber, search)}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </>
  )
}

export default RouteList
